export default __webpack_public_path__ + "static/store-logo-494ed1f47d727b3520c0394552929c90.svg";